import { motion } from "framer-motion";
import { Inbox, MailCheck, Sheet } from "lucide-react";

const SOLUTIONS = [
  {
    icon: Inbox,
    title: "Lead Capture Automation",
    desc: "Every inquiry from forms, DMs, and ads lands in one smart pipeline — instantly tagged and scored.",
    tint: "from-[#007AFF]/20 to-transparent",
    iconColor: "text-[#007AFF]",
  },
  {
    icon: MailCheck,
    title: "Instant Email Follow-Ups",
    desc: "AI-written, on-brand replies go out within seconds — so every lead feels attended to while hot.",
    tint: "from-[#00F0FF]/20 to-transparent",
    iconColor: "text-[#00F0FF]",
  },
  {
    icon: Sheet,
    title: "Google Sheets + Dashboard Sync",
    desc: "Leads, status, and follow-ups sync live to Sheets and a clean dashboard your team actually uses.",
    tint: "from-[#8B5CF6]/20 to-transparent",
    iconColor: "text-[#8B5CF6]",
  },
];

export default function SolutionSection() {
  return (
    <section id="solution" className="relative py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mb-16">
          <p className="text-xs uppercase tracking-[0.25em] text-[#8B5CF6] mb-4" data-testid="solution-kicker">The System</p>
          <h2 className="font-display text-4xl sm:text-5xl font-medium text-white leading-tight" data-testid="solution-heading">
            One connected engine that runs while you sleep.
          </h2>
          <p className="mt-5 text-white/60 text-lg max-w-2xl">
            Three modules. Zero duct tape. Designed for local service businesses that want growth without chaos.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {SOLUTIONS.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              whileHover={{ y: -8 }}
              className="glass-card p-8 relative overflow-hidden group"
              data-testid={`solution-card-${i}`}
            >
              <div className={`absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-gradient-to-br ${s.tint}`} />
              <div className="relative">
                <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-white/[0.04] border border-white/10 mb-6 group-hover:scale-105 transition-transform">
                  <s.icon className={s.iconColor} size={26} />
                </div>
                <h3 className="font-display text-2xl font-medium text-white mb-3">{s.title}</h3>
                <p className="text-white/60 leading-relaxed">{s.desc}</p>
                <div className="mt-8 flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white/40">
                  <span className={`w-1.5 h-1.5 rounded-full ${s.iconColor.replace("text-", "bg-")} animate-pulse`} />
                  Module 0{i + 1}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
